<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex md4">
            <button class="btn btn-primary btn-sm" @click="jumpToNewUserPage">
              <div class="btn-with-icon-content">
                <i class="ion-md-person-add ion"></i>
                {{ "basic.button.new" | translate }}
              </div>
            </button>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="datagridUser">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ "tables.usering.name" | translate }}</th>
                <th>{{ "tables.usering.email" | translate }}</th>
                <th>{{ "tables.usering.createDate" | translate }}</th>
                <th>{{ "tables.usering.status" | translate }}</th>
                <th>{{ "tables.usering.actions" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!isLoading" v-for="(val, index) in userlist" :key="index">
                <td>{{ val.real_name }}</td>
                <td>{{ val.nick_name }}</td>
                <td>{{ val.create_time }}</td>
                <td>{{ val.status === 0 ? $t('statusLabel.disable') : $t('statusLabel.enable') }}</td>
                <td align="right">
                  <span class="action-color-1"></span>
                  <span
                    @click="configUser(val)"
                    class="action-color-1"
                    style="margin-right:15px;"
                    >{{ $t("config") }}</span
                  >
                  <span
                    @click="deleteUser(index)"
                    style="color: #f00; cursor: pointer"
                    >{{ $t("delete") }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <Spinner style="margin: 30px auto" v-if="isLoading" size="small" />
        </div>
        <div class="block"></div>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/utils";
import Spinner from "vue-simple-spinner";
export default {
  name: "UserManagement",
  components: { Spinner },
  data() {
    return {
      userlist: [],
      isLoading: false
    };
  },
  mounted() {
    this.isLoading = true;
    this.drawUserTable();
  },
  methods: {
    configUser(itemObj) {
      sessionStorage.setItem("itemObj", JSON.stringify(itemObj));
      this.$router.push({
        name: "EditUser"
      });
    },
    jumpToNewUserPage() {
      this.$router.push({
        name: "NewUser"
      });
    },
    drawUserTable() {
      let token = localStorage.getItem("Authorization");
      let url = "api/dashboard/app/user/list?access_token=" + token;
      request({
        method: "post",
        url
      }).then(res => {
        if (res.data != undefined) {
          this.userlist = res.data.filter(item => {
            return item.roles.some(i => {
              return i.role_name !== "MERCHANT_ADMIN";
            });
          });
          this.isLoading = false;
        }
      });
    },
    deleteUser(index) {
      let token = localStorage.getItem("Authorization");
      this.$confirm(
        '<strong style="font-size:1rem;">' +
          this.$t("deletedInfo.askInfo") +
          "</strong>",
        this.$t("deletedInfo.title"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirmBtn",
          cancelButtonClass: "cancelBtn",
          confirmButtonText: this.$t("deletedInfo.confirm"),
          cancelButtonText: this.$t("deletedInfo.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          request({
            method: "Delete",
            url:
              "api/dashboard/app/user/delete?del_id=" +
              this.userlist[index].uid +
              "&access_token=" +
              token
          }).then(res => {
            if (res.data.code == 10000) {
              this.userlist.splice(index, 1);
              this.launchToast(
                this.$t("userManagement.delete.success"),
                "fa-exclamation-circle"
              );
            } else {
              this.launchToast(
                this.$t("userManagement.delete.fail"),
                "fa-exclamation-circle"
              );
            }
          });
        })
        .catch(() => {
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              '<strong style="font-size:1rem;">' +
              this.$t("deletedInfo.cancelMsg") +
              "</strong>",
            center: true,
            type: "warning"
          });
        });
    },
    launchToast(msg, icon) {
      this.showToast(msg, {
        icon: icon,
        position: "bottom-center",
        duration: "3000",
        fullWidth: true
      });
    }
  }
};
</script>

<style scoped>
.table th {
  text-align: center;
}

.table td {
  text-align: center;
}
.confirmBtn {
  font-size: 1rem;
}
.cancelBtn {
  font-size: 1rem;
}

.btn-micro {
  letter-spacing: 1px;
}
.btn-with-icon-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  max-width: 160px;
}
.ion {
  width: 22px;
}

@media only screen and (max-width: 750px) {
  #datagridUser.vuestic-widget .vuestic-widget-body {
    padding: 0.2rem;
  }
}
</style>

<style lang="scss">
.action-color-1 {
  color: $action-color;
  cursor:pointer;
}
</style>
